import { careplanConstants as constants } from '../_constants/careplan.constants';

export const initialState = {
  favorites: [],
  files: [],
  favoriteId: null,
  current: {
    status: 'in-progress',
    physicalExam: '',
    imaging: '',
    diagnosis: '',
    carePlan: '',
    attachments: []
  }
}

export function careplan(state = initialState, action) {
  if (action.type === constants.FCP_ADD_SET) {
    const list = state.favorites;
    list.push(action.favorite)

    return {
      ...state,
      favoriteId: action.favorite.id,
      favorites: list
    }
  }

  if (action.type === constants.FCP_SET_FAVORITE) {
    return {
      ...state,
      favoriteId: action.favorite.id,
      current: {
        ...state.current,
        physicalExam: action.favorite.physicalExam || '',
        imaging: action.favorite.imaging || '',
        diagnosis: action.favorite.diagnosis || '',
        carePlan: action.favorite.carePlan || ''
      }
    }
  }

  if (action.type === constants.FCP_SET_FILES) {
    return {
      ...state,
      files: action.files
    }
  }

  if (action.type === constants.FCP_SET_CURRENT) {
    return {
      ...state,
      current: {
        status: action.carePlan ? action.carePlan.status : 'in-progress',
        physicalExam: action.carePlan ? action.carePlan.physicalExam : '',
        imaging: action.carePlan ? action.carePlan.imaging : '',
        diagnosis: action.carePlan ? action.carePlan.diagnosis : '',
        carePlan: action.carePlan ? action.carePlan.carePlan : '',
        attachments: action.carePlan ? action.carePlan.attachments : []
      }
    }
  }

  if (action.type === constants.FCP_CLEAR_CURRENT) {
    return {
      ...state,
      files: [],
      favoriteId: null,
      current: initialState.current
    }
  }

  if (action.type === constants.FCP_SET_ATTACHMENTS) {
    return {
      ...state,
      current: {
        ...state.current,
        attachments: action.attachments
      }
    }
  }

  if (action.type === constants.FCP_SET_CARE_PLAN) {
    return {
      ...state,
      current: {
        ...state.current,
        carePlan: action.text
      }
    }
  }

  if (action.type === constants.FCP_SET_DIAGNOSIS) {
    return {
      ...state,
      current: {
        ...state.current,
        diagnosis: action.text
      }
    }
  }

  if (action.type === constants.FCP_SET_IMAGING) {
    return {
      ...state,
      current: {
        ...state.current,
        imaging: action.text
      }
    }
  }

  if (action.type === constants.FCP_SET_PHYSICAL_EXAM) {
    return {
      ...state,
      current: {
        ...state.current,
        physicalExam: action.text
      }
    }
  }

  if (action.type === constants.FCP_RETRIEVE_SUCCESS) {
    return {
      ...state,
      favorites: action.favorites
    }
  }

  return state
}